<template>
  <div class="w-100">
    <slot></slot>
  </div>
</template>

<script>
  import 'jquery-validation'
  
  export default {
    name: 'EditUserPassword',
    props: ['user'],
    methods: {},
    mounted () {
      /**
       * Init JQuery validation
       */
      $(() => {
        $('.form').validate({
          ignore: [],
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            label.addClass('invalid-feedback')
            label.insertAfter(element)
          },
          rules: {
            current_password: {
              required: true,
            },
            password: {
              required: true,
            },
            password_confirmation: {
              required: true,
              equalTo: '#password',
            },
          },
          messages: {
            current_password: {
              required: 'Este campo es requerido.',
            },
            password: {
              required: 'Este campo es requerido.',
            },
            password_confirmation: {
              required: 'Este campo es requerido.',
              equalTo: 'La contraseña no coincide',
            },
          },
          submitHandler (form) {
            $('#btn-save, #btn-cancel').prop('disabled', true)
            $('#btn-save').find('.spinner-border').removeClass('d-none')
            
            form.submit()
          },
        })
      })
    },
  }
</script>
